<template>
  <div v-if="showPage403" class="animated content-holder">
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-note"></i> Product
          {{ products_id ? " - Edit" : " - New" }}
        </div>
        <b-button-group>
          <b-button v-on:click="routerBack()" class="custom-cancel"
            ><i class="fa fa-times text-danger"></i>
            Cancel
          </b-button>
          <b-button
            v-on:click="post('andClose')"
            :disabled="disabled || submitted"
            ><i class="fa fa-save"></i> Save & Close
          </b-button>
          <b-button v-on:click="post()" :disabled="disabled"
            ><i class="fa fa-check text-success "></i> Apply</b-button
          >
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="8">
            <b-form
              v-on:submit.prevent="onSubmit"
              v-on:reset.prevent="onReset"
              novalidate
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="nameInputGroup1"
                    label="Product Title"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      type="text"
                      v-model.lazy.trim="$v.form.name.$model"
                      :state="chkState('name')"
                      aria-describedby="input1LiveFeedback1"
                      placeholder="Name"
                      autocomplete="given-name"
                      autofocus
                    />
                    <b-form-invalid-feedback id="input1LiveFeedback1">
                      This is a required field and must be at least 2 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <label id="company" class="d-block">Product Company</label>
                  <b-form-select
                    id="selectcompany"
                    label="Company"
                    class="form-group"
                    :options="this.companyListOptions"
                    v-model.lazy.trim="$v.form.company_id.$model"
                    value="Please select"
                  >
                  </b-form-select>
                </b-col>
              </b-row>

              <hr class="mnr-md mnl-md" />

              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="skuInputGroup1"
                    label="Product SKU"
                    label-for="sku"
                  >
                    <b-form-input
                      id="sku"
                      type="text"
                      v-model.lazy.trim="$v.form.sku.$model"
                      aria-describedby="input1LiveFeedback2"
                      placeholder="SKU"
                    />
                    <b-form-invalid-feedback id="input1LiveFeedback2">
                      This is a required field and must be at least 2 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="codeInputGroup1"
                    label="Product Code"
                    label-for="code"
                  >
                    <b-form-input
                      id="code"
                      type="text"
                      v-model.lazy.trim="$v.form.code.$model"
                      aria-describedby="input1LiveFeedback7"
                      placeholder="Product Code"
                    />
                    <b-form-invalid-feedback id="input1LiveFeedback7">
                      This is a required field and must be at least 2 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="mnr-md mnl-md" />

              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="priceInputGroup1"
                    label="Product Price"
                    label-for="price"
                  >
                    <b-form-input
                      id="price"
                      type="number"
                      v-model.lazy.trim="$v.form.price.$model"
                      aria-describedby="input1LiveFeedback3"
                      placeholder="Product Price"
                    />
                    <b-form-invalid-feedback id="input1LiveFeedback3">
                      This is a required field and must be at least 2 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <label id="categories" class="d-block"
                    >Product Category</label
                  >
                  <b-form-select
                    id="selectCategories"
                    label="categories"
                    class="form-group"
                    :options="this.categoryListOptions"
                    v-model.lazy.trim="$v.form.categories_id.$model"
                    value="Please select"
                  >
                  </b-form-select>
                </b-col>
              </b-row>

              <hr class="mnr-md mnl-md" />
              <!-- Active Value -->
              <b-row>
                <b-col>
                  <b-form-group
                    label="Product Active"
                    label-for="active"
                    label-class="font-weight-bold pt-0"
                  >
                    <c-switch
                      class="mx-1"
                      dataOn=""
                      dataOff=""
                      color="success"
                      :checked="form.pro_active"
                      label
                      v-model.lazy="form.pro_active"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <br />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-row>
              <b-col>
                <b-card class="mb-2">
                  <b-form-group
                    label="Image Front"
                    label-for="uploadImgFront"
                    label-class="font-weight-bold pt-0"
                    class="margin-bottom-25"
                  >
                    <b-form-file
                      id="uploadImgFront"
                      multiple
                      :file-name-formatter="formatNames"
                      v-model="form.uploadImgFront"
                      placeholder="Choose file or drop here..."
                      drop-placeholder="Drop file here..."
                    >
                    </b-form-file>
                  </b-form-group>
                  <a
                    v-if="showImgFront"
                    target="_blank"
                    :href="`${showImgFront}`"
                    data-toggle="ajax"
                  >
                    <img
                      :src="`${showImgFront}`"
                      class=""
                      style="height:300px;width:auto;max-width:100%"
                    />
                  </a>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card class="mb-2">
                  <b-form-group
                    label="Image Back"
                    label-for="uploadImgBack"
                    label-class="font-weight-bold pt-0"
                    class="margin-bottom-25"
                  >
                    <b-form-file
                      id="uploadImgBack"
                      multiple
                      :file-name-formatter="formatNames"
                      v-model="form.uploadImgBack"
                      placeholder="Choose file or drop here..."
                      drop-placeholder="Drop file here..."
                    >
                    </b-form-file>
                  </b-form-group>
                  <b-col>
                    <a
                      v-if="showImgBack"
                      target="_blank"
                      :href="`${showImgBack}`"
                      data-toggle="ajax"
                    >
                      <img
                        :src="`${showImgBack}`"
                        class=""
                        style="height:300px;width:auto;max-width:100%"
                      />
                    </a>
                  </b-col>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <b-row>
              <b-col>
                <b-card class="mb-2">
                  <b-form-group
                    label="Image Package"
                    label-for="uploadImgPack"
                    label-class="font-weight-bold pt-0"
                    class="margin-bottom-25"
                  >
                    <b-form-file
                      id="uploadImgPack"
                      multiple
                      :file-name-formatter="formatNames"
                      v-model="form.uploadImgPack"
                      placeholder="Choose file or drop here..."
                      drop-placeholder="Drop file here..."
                    >
                    </b-form-file>
                  </b-form-group>
                  <a
                    v-if="showImgPack"
                    target="_blank"
                    :href="`${showImgPack}`"
                    data-toggle="ajax"
                  >
                    <img
                      :src="`${showImgPack}`"
                      class=""
                      style="height:300px;width:auto;max-width:100%"
                    />
                  </a>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card class="mb-2">
                  <b-form-group
                    label="Image Box"
                    label-for="uploadImgBox"
                    label-class="font-weight-bold pt-0"
                    class="margin-bottom-25"
                  >
                    <b-form-file
                      id="uploadImgBox"
                      multiple
                      :file-name-formatter="formatNames"
                      v-model="form.uploadImgBox"
                      placeholder="Choose file or drop here..."
                      drop-placeholder="Drop file here..."
                    >
                    </b-form-file>
                  </b-form-group>

                  <a
                    v-if="showImgBox"
                    target="_blank"
                    :href="`${showImgBox}`"
                    data-toggle="ajax"
                  >
                    <img
                      :src="`${showImgBox}`"
                      class=""
                      style="height:300px;width:auto;max-width:100%"
                    />
                  </a>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Modal Component -->
    <div>
      <Modals ref="form"></Modals>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import { Switch as cSwitch } from "@coreui/vue";
import { router } from "../../router/index";
import { mapState, mapActions } from "vuex";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import { cipher } from "@/shared/cipher";
import { userPool } from "@/shared/cognito";
import ActivityLog from "@/containers/ActivityLog";
import { ClientTable, Event } from "vue-tables-2";
import Modals from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);
Vue.use(ClientTable);
const formShape = {
  name: "",
  sku: "",
  price: "",
  categories_id: "",
  company_id: ""
};
let validations = {
  form: {
    name: {
      required: true
    },
    company_id: {
      required: true
    },
    sku: {
      required: true
    },
    code: {
      required: true
    },
    price: {
      required: true
    },
    categories_id: {
      required: true
    }
  }
};
export default {
  name: "User",
  components: {
    cSwitch,
    Spinner,
    ActivityLog,
    Modals,
    Page403
  },
  data() {
    // check route here, new or edit
    let newModePage = true;
    if (window.location.href.includes("/products/product/edit")) {
      var products_id = localStorage.getItem("page_products_id");
      newModePage = false;
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false
        }
      },
      showPage403: false,
      newModePage: newModePage,
      form: Object.assign({}, formShape),
      feedBack: "secondary",
      products_id: products_id || null,
      submitted: false,
      name: null,
      sku: null,
      price: null,
      code: null,
      disabled: true,
      isLoading: true,
      companyListOptions: [],
      categoryListOptions: [],
      uploadImgFront: [],
      uploadedImgFront: [],
      uploadImgBack: [],
      uploadedImgBack: [],
      uploadImgPack: [],
      uploadedImgPack: [],
      uploadImgBox: [],
      uploadedImgBox: [],
      showImgFront: null,
      showImgBack: null,
      showImgPack: null,
      showImgBox: null,
      markedUploadedFilesToRemove: [],
      companyListIds: [],
      pro_active: true,
      preview_blob: null,
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      deleteModalOpen: false,
      id: null,
      title: null,
      object_id: null,
      infoModalTitle: null,
      infoModalOpen: false,
      infoModalBody: null,
      infoModalOkVariant: "success"
    };
  },
  mounted: function() {
    let that = this;
    that.getPermission();
    if (that.newModePage && !that.permission.capabilities.Create) {
      that.showPage403 = true;
      return;
    } else if (!that.newModePage && !that.permission.capabilities.Edit) {
      that.showPage403 = true;
      return;
    }
    this.getCompaniesData();
    this.getCategoryData();
    if (that.products_id) {
      this.getProductsData();
    } else {
      this.isLoading = false;
    }
  },
  computed: {
    formStr() {
      return JSON.stringify(this.form, null, 4);
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    }
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPermission() {
      let that = this;
      const userPermissionsBasedOnEntity =
        that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if (this.$route.meta && userPermissionsBasedOnEntity) {
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(
          p => p.permissionBaseName === this.$route.meta.permissionBaseName
        );
        if (userPermissionBasedOnEntity) {
          that.permission.permissionBaseNameCapabilities =
            userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability => {
            that.permission.capabilities[capability.label] = capability.value;
          });
        }
      } else {
        router.push("/no-permission-given");
      }
    },
    openDeleteModal: function(id) {
      this.deleteModalOpen = true;
      this.id = id;
      this.object_id = this.data[id].object_id;
      this.title = this.data[id].objectName;
    },
    loadAndUpdateTableListAfterItemDelete: function(that) {
      that.data.splice(that.id, 1);
      for (let i = that.id; i < that.data.length; i++) {
        that.data[i].id--;
      }
      that.isLoading = false;
    },
    initializeInfoModal: function(modalOpen, title, body, okvariant, that) {
      that.infoModalOpen = modalOpen;
      that.infoModalTitle = title;
      that.infoModalBody = body;
      that.infoModalOkVariant = okvariant;
    },
    routerBack() {
      this.$router.push('/products');
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true;
          this.feedBack = "info";
        });
      }
    },
    onReset() {
      this.form = Object.assign({}, formShape);
      this.submitted = false;
      this.$nextTick(() => {
        this.$v.$reset();
        this.feedBack = "secondary";
      });
    },
    chkState(val) {
      const field = this.$v.form[val];
      let name = this.$v.form["name"];
      let sku = this.$v.form["sku"];
      let price = this.$v.form["price"];
      let code = this.$v.form["code"];
      let categories = this.$v.form["categories_id"];
      let company = this.$v.form["company_id"];
      let basicFieldsInvalid =
        name.$invalid || sku.$invalid || price.$invalid || code.$invalid;

      if (!this.pwdFieldsVisible && this.user_id) {
        this.disabled = basicFieldsInvalid;
      } else {
        this.disabled = basicFieldsInvalid;
      }
      return !field.$dirty || !field.$invalid;
    },

    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus();
          return true;
        }
        if (component.$refs.check) {
          component.$refs.check.focus();
          return true;
        }
      }
      let focused = false;
      component.$children.some(child => {
        focused = this.findFirstError(child);
        return focused;
      });
      return focused;
    },
    validate() {
      this.$v.$touch();
      this.$nextTick(() => this.findFirstError());
      return this.isValid;
    },
    getCompaniesData: function() {
      var method = "GET";
      var pathTemplate = "/companies";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          var datas = results["data"]["data"];
          for (var i = 0; i < datas.length; i++) {
            var companyListJSON = {
              value: datas[i]["id"],
              text: datas[i]["companyName"]
            };
            that.companyListOptions.push(companyListJSON);
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
        });
    },
    getCategoryData: function() {
      var method = "GET";
      var pathTemplate = "/categories";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "typeName",
                comparisonOperator: "=",
                value: "products"
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          var datas = results["data"]["data"];
          for (var i = 0; i < datas.length; i++) {
            var categoryListJSON = {
              value: datas[i]["id"],
              text: datas[i]["categoryName"]
            };
            that.categoryListOptions.push(categoryListJSON);
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
        });
    },
    getProductsData: function() {
      var method = "GET";
      var pathTemplate = "/products/" + this.products_id;
      var additionalParams = {};
      var pathParams = {};
      var productsData = [];
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          productsData = result["data"]["data"];
          that.form.name = productsData.product_name;
          that.form.company_id = productsData.company_id;
          that.form.sku = productsData.sku;
          that.form.price = productsData.price;
          that.form.code = productsData.code;
          that.form.categories_id = productsData.categories_id;
          that.form.pro_active = productsData.active;
          that.uploadImgFront = productsData.product_imgFront;
          that.uploadedImgFront = productsData.product_imgFront;
          that.uploadImgBack = productsData.product_imgBack;
          that.uploadedImgBack = productsData.product_imgBack;
          that.uploadImgPack = productsData.product_imgPack;
          that.uploadedImgPack = productsData.product_imgPack;
          that.uploadImgBox = productsData.product_imgBox;
          that.uploadedImgBox = productsData.product_imgBox;
          that.showImgFront = productsData.product_imgFront.filepath;
          that.showImgBack = productsData.product_imgBack.filepath;
          that.showImgPack = productsData.product_imgPack.filepath;
          that.showImgBox = productsData.product_imgBox.filepath;
          that.isLoading = false;
        })
        .catch(function(error) {
          that.isLoading = false;
        });
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    post: function(option) {
      this.$refs.form.openModal();
      this.changeModalContent("loading", "Saving...", "Saving User Info");
      var that = this;
      const validationResult = this.$validator.validateAll().then(result => {
        if (result) {
          let uploadedFilesWithS3Info = {
            productFrontFilesWithS3Info: [],
            productBackFilesWithS3Info: [],
            productPackFilesWithS3Info: [],
            productBoxFilesWithS3Info: [],
            s3UploadErrors: []
          };
          if (
            that.form.uploadImgFront ||
            that.form.uploadImgBack ||
            that.form.uploadImgPack ||
            that.form.uploadImgBox
          ) {
            let domain = "";
            if (that.loginUserInfo.db.company.subdomain) {
              domain = that.loginUserInfo.db.company.subdomain;
            } else if (that.loginUserInfo.db.company.fulldomain) {
              domain = that.loginUserInfo.db.company.fulldomain;
            } else {
              domain = "shatterizer.cn2.ypb.io";
            }
            let companyId =
              that.loginUserInfo.db.company.id == null ||
              that.loginUserInfo.db.company.id == undefined ||
              that.loginUserInfo.db.company.id == "NULL"
                ? ""
                : that.loginUserInfo.db.company.id;
            let filesToGetPresignedURL = {
              bucketName: "connect2resource",
              subPath:
                "finance" + "/" + "companies" + "/" + companyId + "/" + domain,
              files: []
            };
            if (that.form.uploadImgFront) {
              that.form.uploadImgFront.forEach(function(_file) {
                var fileToGetPresignedURL = {};
                fileToGetPresignedURL["name"] =
                  "productFrontFile_" + _file.name;
                fileToGetPresignedURL["extension"] = _file.name
                  .split(".")
                  .pop();
                fileToGetPresignedURL["type"] = _file.type;

                let id = "productFrontFile_" + uuid.v4();
                fileToGetPresignedURL["id"] = id;
                _file.id = id;
                _file.fileCategory = "frontFile";

                filesToGetPresignedURL.files.push(fileToGetPresignedURL);
              });
            }
            if (that.form.uploadImgBack) {
              that.form.uploadImgBack.forEach(function(_file) {
                var fileToGetPresignedURL = {};
                fileToGetPresignedURL["name"] = "productBackFile_" + _file.name;
                fileToGetPresignedURL["extension"] = _file.name
                  .split(".")
                  .pop();
                fileToGetPresignedURL["type"] = _file.type;

                let id = "productBackFile_" + uuid.v4();
                fileToGetPresignedURL["id"] = id;
                _file.id = id;
                _file.fileCategory = "backFile";

                filesToGetPresignedURL.files.push(fileToGetPresignedURL);
              });
            }
            if (that.form.uploadImgPack) {
              that.form.uploadImgPack.forEach(function(_file) {
                var fileToGetPresignedURL = {};
                fileToGetPresignedURL["name"] = "productPackFile_" + _file.name;
                fileToGetPresignedURL["extension"] = _file.name
                  .split(".")
                  .pop();
                fileToGetPresignedURL["type"] = _file.type;
                let id = "productPackFile_" + uuid.v4();
                fileToGetPresignedURL["id"] = id;
                _file.id = id;
                _file.fileCategory = "packFile";

                filesToGetPresignedURL.files.push(fileToGetPresignedURL);
              });
            }
            if (that.form.uploadImgBox) {
              that.form.uploadImgBox.forEach(function(_file) {
                var fileToGetPresignedURL = {};
                fileToGetPresignedURL["name"] = "productBoxFile_" + _file.name;
                fileToGetPresignedURL["extension"] = _file.name
                  .split(".")
                  .pop();
                fileToGetPresignedURL["type"] = _file.type;
                let id = "productBoxFile_" + uuid.v4();
                fileToGetPresignedURL["id"] = id;
                _file.id = id;
                _file.fileCategory = "boxFile";
                filesToGetPresignedURL.files.push(fileToGetPresignedURL);
              });
            }
            var method = "POST";
            var pathTemplate = "/s3/presignedurls";
            var additionalParams = {};
            var body = filesToGetPresignedURL;
            var pathParams = {};
            apigClient
              .invokeApi(
                pathParams,
                pathTemplate,
                method,
                additionalParams,
                body
              )
              .then(function(result) {
                let filePresignedURLs = result.data;
                let countOfFilesThatHavePresignedURL = 0;
                filePresignedURLs.forEach(function(_fileP) {
                  if (
                    _fileP.s3_presignedURL != null &&
                    _fileP.s3_presignedURL != undefined
                  ) {
                    countOfFilesThatHavePresignedURL++;
                  }
                });
                let uploadFilesRequests = filePresignedURLs.map(
                  _filePresignURL => {
                    return new Promise(resolve => {
                      that.uploadFilesToS3AndGetFilesURL(
                        _filePresignURL,
                        uploadedFilesWithS3Info,
                        resolve
                      );
                    });
                  }
                );
                Promise.all(uploadFilesRequests).then(() => {
                  if (uploadedFilesWithS3Info.s3UploadErrors.length > 0) {
                    uploadedFilesWithS3Info.s3UploadErrors.forEach(error => {
                      console.log("-- " + error);
                    });
                    that.showFilesUploadWarnMsg();
                  }
                  that.saveProducts(uploadedFilesWithS3Info, option);
                });
              });
          } else {
            that.saveProducts(null, option);
          }
        }
      });
    },
    uploadFilesToS3AndGetFilesURL: async function(
      _filePresignURL,
      uploadedFilesWithS3Info,
      resolve
    ) {
      var that = this;
      const axios = require("axios");
      let file =
        (that.form.uploadImgFront != undefined
          ? that.form.uploadImgFront.find(f => f.id === _filePresignURL.id)
          : "") ||
        (that.form.uploadImgBack != undefined
          ? that.form.uploadImgBack.find(f => f.id === _filePresignURL.id)
          : "") ||
        (that.form.uploadImgPack != undefined
          ? that.form.uploadImgPack.find(f => f.id === _filePresignURL.id)
          : "") ||
        (that.form.uploadImgBox != undefined
          ? that.form.uploadImgBox.find(f => f.id === _filePresignURL.id)
          : "");

      if (file) {
        if (
          _filePresignURL.s3_presignedURL != null &&
          _filePresignURL.s3_presignedURL != undefined
        ) {
          const options = {
            headers: {
              "Content-Type": file.type
            }
          };
          try {
            const res = await axios.put(
              _filePresignURL.s3_presignedURL,
              file,
              options
            );
            if (res && res.config.url) {
              var fileUrl = res.config.url;
              var indexToRemove = fileUrl.indexOf("?");
              fileUrl = fileUrl.substr(0, indexToRemove);
              if (file.fileCategory == "frontFile") {
                uploadedFilesWithS3Info.productFrontFilesWithS3Info.push({
                  id: _filePresignURL.id,
                  filename: _filePresignURL.filename,
                  mime: file.type,
                  size: file.size,
                  filepath: fileUrl
                });
              }
              if (file.fileCategory == "backFile") {
                uploadedFilesWithS3Info.productBackFilesWithS3Info.push({
                  id: _filePresignURL.id,
                  filename: _filePresignURL.filename,
                  mime: file.type,
                  size: file.size,
                  filepath: fileUrl
                });
              }
              if (file.fileCategory == "packFile") {
                uploadedFilesWithS3Info.productPackFilesWithS3Info.push({
                  id: _filePresignURL.id,
                  filename: _filePresignURL.filename,
                  mime: file.type,
                  size: file.size,
                  filepath: fileUrl
                });
              }
              if (file.fileCategory == "boxFile") {
                uploadedFilesWithS3Info.productBoxFilesWithS3Info.push({
                  id: _filePresignURL.id,
                  filename: _filePresignURL.filename,
                  mime: file.type,
                  size: file.size,
                  filepath: fileUrl
                });
              }
              resolve("finished");
            } else {
              uploadedFilesWithS3Info.s3UploadErrors.push(
                _filePresignURL.filename + ": S3Upload Error"
              );
              resolve("finished");
            }
          } catch (error) {
            uploadedFilesWithS3Info.s3UploadErrors.push(
              _filePresignURL.filename + ": " + error
            );
            resolve("finished");
          }
        }
      }
    },
    saveProducts: function(uploadedFilesWithS3Info = null, option) {
      var that = this;
      this.isLoading = true;
      var s3InvoiceWorkOrderfilesToDelete = {
        Bucket: "connect2resource",
        Delete: {
          Objects: [],
          Quiet: false
        }
      };
      if (that.markedUploadedFilesToRemove.length > 0) {
        that.markedUploadedFilesToRemove.forEach(markedFileIdToRemove => {
          let file =
            that.form.uploadImgFront.find(f => f.id === markedFileIdToRemove) ||
            that.form.uploadImgBack.find(f => f.id === markedFileIdToRemove) ||
            that.form.uploadImgPack.find(f => f.id === markedFileIdToRemove) ||
            that.form.uploadImgBox.find(f => f.id === markedFileIdToRemove);
          const { key } = AmazonS3URI(file.filepath);
          s3InvoiceWorkOrderfilesToDelete.Delete.Objects.push({
            Key: key
          });
          let markedToRemoveFrontFileIndex = that.form.uploadImgFront.findIndex(
            f => f.id === markedFileIdToRemove
          );
          let markedToRemoveBackFileIndex = that.form.uploadImgBack.findIndex(
            f => f.id === markedFileIdToRemove
          );
          let markedToRemovePackFileIndex = that.form.uploadImgPack.findIndex(
            f => f.id === markedFileIdToRemove
          );
          let markedToRemoveBoxFileIndex = that.form.uploadImgBox.findIndex(
            f => f.id === markedFileIdToRemove
          );
          if (markedToRemoveFrontFileIndex >= 0) {
            that.form.uploadImgFront.splice(markedToRemoveFrontFileIndex, 1);
          }
          if (markedToRemoveBackFileIndex >= 0) {
            that.form.uploadImgBack.splice(markedToRemoveBackFileIndex, 1);
          }
          if (markedToRemovePackFileIndex >= 0) {
            that.form.uploadImgPack.splice(markedToRemovePackFileIndex, 1);
          }
          if (markedToRemoveBoxFileIndex >= 0) {
            that.form.uploadImgBox.splice(markedToRemoveBoxFileIndex, 1);
          }
        });
      }

      if (uploadedFilesWithS3Info != null) {
        if (uploadedFilesWithS3Info.productFrontFilesWithS3Info != null) {
          uploadedFilesWithS3Info.productFrontFilesWithS3Info.forEach(
            productFrontFile => {
              that.uploadedImgFront = productFrontFile;
            }
          );
        }
        if (uploadedFilesWithS3Info.productBackFilesWithS3Info != null) {
          uploadedFilesWithS3Info.productBackFilesWithS3Info.forEach(
            productBackFile => {
              that.uploadedImgBack = productBackFile;
            }
          );
        }
        if (uploadedFilesWithS3Info.productPackFilesWithS3Info != null) {
          uploadedFilesWithS3Info.productPackFilesWithS3Info.forEach(
            productPackFile => {
              that.uploadedImgPack = productPackFile;
            }
          );
        }
        if (uploadedFilesWithS3Info.productBoxFilesWithS3Info != null) {
          uploadedFilesWithS3Info.productBoxFilesWithS3Info.forEach(
            productBoxFile => {
              that.uploadedImgBox = productBoxFile;
            }
          );
        }
      }
      if (this.products_id) {
        var method = "PUT";
        var pathTemplate = "/products/" + this.products_id;
        var additionalParams = {};
        var pathParams = {};
        var body = {
          product_name: that.form.name,
          company_id: that.form.company_id,
          sku: that.form.sku,
          price: that.form.price,
          code: that.form.code,
          categories_id: that.form.categories_id,
          active: that.form.pro_active,
          updateBy: that.loginUserInfo.login_username,
          product_imgFront: that.uploadedImgFront,
          product_imgBack: that.uploadedImgBack,
          product_imgPack: that.uploadedImgPack,
          product_imgBox: that.uploadedImgBox
        };
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            that.showSuccessMsgCreate();
            if (option == "andClose") {
              that.changeModalContent(
                "success",
                "Saved success!",
                "The User data has been created"
              );
              setTimeout(() => {
                router.push(`/products`);
              }, 2000);
            } else {
              that.changeModalContent(
                "success",
                "Saved success!",
                "The User data has been created"
              );
              setTimeout(() => {
                that.$refs.form.closeModal();
              }, 2000);
            }
          })
          .catch(function(result) {
            that.changeModalContent(
              "error",
              "Error Occured!",
              " " + result.message
            );
          });
      } else {
        var method = "POST";
        var pathTemplate = "/products";
        var additionalParams = {};
        var pathParams = {};
        var body = {
          product_name: that.form.name,
          company_id: that.form.company_id,
          sku: that.form.sku,
          price: that.form.price,
          code: that.form.code,
          active: that.form.pro_active,
          categories_id: that.form.categories_id,
          createdBy: that.loginUserInfo.login_username,
          product_imgFront: that.uploadedImgFront,
          product_imgBack: that.uploadedImgBack,
          product_imgPack: that.uploadedImgPack,
          product_imgBox: that.uploadedImgBox
        };
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
          .then(function(result) {
            that.showSuccessMsgCreate();
            if (option == "andClose") {
              localStorage.setItem("page_products_id", result["data"]["data"]);
              that.changeModalContent(
                "success",
                "Saved success!",
                "The User data has been created"
              );
              setTimeout(() => {
                router.push(`/products`);
              }, 2000);
            }
          })
          .catch(function(result) {
            that.changeModalContent(
              "error",
              "Error Occured!",
              " " + result.message
            );
          });
      }
      this.isLoading = false;
    },
    markUploadedFileToRemove(fileId) {
      var that = this;
      let fileIsAlreadyInMarkedListIndex = that.form.markedUploadedFilesToRemove.findIndex(
        s => s === fileId
      );
      if (fileIsAlreadyInMarkedListIndex >= 0) {
        that.form.markedUploadedFilesToRemove.splice(
          fileIsAlreadyInMarkedListIndex,
          1
        );
      } else {
        that.form.markedUploadedFilesToRemove.push(fileId);
      }
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    }
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The product has been created"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The product has been updated"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "The product cannot be saved"
    },
    showErrorCognito: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message:
        "This product cannot be authenticated, please make sure this products have been confirmed by email"
    },
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Product has been deleted"
    }
  },
  showFilesUploadWarnMsg: {
    type: VueNotifications.types.warn,
    title: "Warning",
    message:
      "Error in Image Files Uploads! See console for additional error logs. Will continue saving the object info."
  }
};
</script>

<style scoped>
.btn.disabled {
  cursor: auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  border: 1px solid #a4acb5;
}
@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }
  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.custom-cancel {
  border-radius: 0.25rem 0 0 0.25rem;
}
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}
</style>

<style>
#language {
  margin-top: 15px;
}
.custom-header {
  display: flex;
  justify-content: space-between;
}
select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}
/* For IE10 */
select::-ms-expand {
  display: none;
}
</style>
